<template>
  <CareWebview class="bg-surface-brand-hi">
    <Home />
  </CareWebview>
</template>

<script setup lang="ts">
import CareWebview from '~/scopes/care-commons/webview/CareWebview.vue'

import Home from '../components/LegacyHelpCenterHome/LegacyHelpCenterHome.vue'
</script>
